import React from "react";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const vatSettlementListSections = ["SALE", "PURCHASE", "PURCHASE_NON_DETRAIBILE", "IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0730"];
const vatSettlementListSectionsDetailCorrelation = {
  SALE: "SALE",
  PURCHASE: "PURCHASE",
  PURCHASE_NON_DETRAIBILE: "PURCHASE",
  IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0730: "SALE"
};
const vatSettlementListSectionsText = {
  SALE: "Vendite",
  PURCHASE: "Acquisti",
  PURCHASE_NON_DETRAIBILE: "Acquisti non detraibili",
  IVA_DETRAIBILE_AGRICOLTURA_SPECIALE_0730: "Iva detraibile agricoltura % comp. 7,3%"
};

export const vatSettlementListConversion = (report, reduxData) => {
  const additionalData = reduxData?.additionalData;
  let workedRows = [];
  vatSettlementListSections.map((section) => {
    if (report.details?.[section]) {
      workedRows.push({
        description: vatSettlementListSectionsText[section],
        amount: report.details[section].taxableAmount,
        tax: report.details[section].vatAmount,
        total: report.details[section].totalAmount,
        accordion: true
      });
      return report.details?.[section].rates.map((rate) => {
        return workedRows.push({
          vatCode: rate.vatRate,
          rateDescription: additionalData?.vatSettlementRates?.[rate.vatRate] ? additionalData?.vatSettlementRates?.[rate.vatRate] : rate.rate,
          amount: rate.taxableAmount,
          tax: rate.vatAmount,
          total: rate.totalAmount,
          journalType: vatSettlementListSectionsDetailCorrelation[section],
          subRow: true,
          hasDetails: true
        });
      });
    }
    return null;
  });
  let reportJson = {
    header: [
      { id: "description", label: "Descrizione" },
      { id: "vatCode", label: "Aliquota/Esenzione" },
      { id: "rateDescription", label: "Descrizione aliquota" },
      { id: "amount", label: "Imponibile" },
      { id: "tax", label: "Imposta" },
      { id: "total", label: "Totale" }
    ],
    rows: workedRows
  };
  return reportJson;
};

export const vatSettlementDetailsConversion = (
  details, reduxData, goToPrecogDetail
) => {
  const additionalData = reduxData?.additionalData;
  if (!details) {
    return null;
  }
  let summary = {
    vatCode: "",
    "Descrizione aliquota": "",
    Imponibile: 0,
    Imposta: 0,
    Totale: 0
  };
  let workedRows = [];
  let cn = 0;

  details.map((detail) => {
    cn++;
    if (cn === 1) {
      summary = {
        vatCode: detail.rateDetail.vatRate,
        vatDescription: additionalData?.vatSettlementRates?.[detail.rateDetail.vatRate] || "",
        amount: detail.rateDetail.taxableAmount,
        tax: detail.rateDetail.vatAmount,
        total: detail.rateDetail.totalAmount
      };
    } else {
      summary = {
        ...summary,
        amount: summary["Imponibile"] + detail.rateDetail.taxableAmount,
        total: summary["Totale"] + detail.rateDetail.totalAmount
      };
    }
    return workedRows.push({
      "Causale documento": detail.reasonId,
      "Tipo documento": detail.journalType,
      "Data registrazione": moment(detail.postingDate).format("DD/MM/YYYY"),
      "Numero documento": detail.document.number,
      "Data documento": moment(detail.document.date).format("DD/MM/YYYY"),
      "Codice iva": detail.rateDetail.vatRate,
      Imponibile: detail.rateDetail.taxableAmount,
      Imposta: detail.rateDetail.vatAmount,
      "Totale riga": detail.rateDetail.totalAmount,
      " ": (
        <span style={{ cursor: "pointer" }} onClick={() => goToPrecogDetail("eb875279-c091-4813-b8b2-a5e546d252ba")}>
          <FontAwesomeIcon icon={["far", "arrow-right"]} style={{ color: "var(--brand-primary)" }} />
        </span>
      )
    });
  });

  let reportJson = {
    summaryHeader: [
      { id: "vatCode", label: "Aliquota" },
      { id: "vatDescription", label: "Descrizione aliquota" },
      { id: "amount", label: "Imponibile" },
      { id: "tax", label: "Imposta" },
      { id: "total", label: "Totale" }
    ],
    summary: summary,
    header: [
      "Causale documento",
      "Tipo documento",
      "Data registrazione",
      "Numero documento",
      "Data documento",
      "Codice iva",
      "Imponibile",
      "Imposta",
      "Totale riga",
      " "
    ],
    rows: workedRows
  };
  return reportJson;
};
